import { Directive,HostListener, Input, } from '@angular/core';

@Directive({
    selector: '[ToolTipDirective]',
    standalone: false
})
export class ToolTipDirective {
  @Input() title: string = ''
  @Input() index: number = 0;
  @Input() selector: string = '';
  constructor(  ) { }


  @HostListener('mouseenter')
  onMouseEnter(): void {
    if (this.index >= 0 && this.selector) {
      const getQuerySelector = document.querySelector(`.${this.selector}-${this.index}`);
      getQuerySelector.classList.remove('apprasial_show')
      getQuerySelector.classList.add('show_tooltip')
    }
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.destroy();
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  destroy(): void {
    const getQuerySelector = document.querySelector(`.${this.selector}-${this.index}`);
    getQuerySelector.classList.remove('show_tooltip')
    getQuerySelector.classList.add('apprasial_show')
  }
}
